import { Html, useProgress } from "@react-three/drei";
import React from "react";
import loading from "./loading.gif";

const Loader = () => {
  const { progress } = useProgress();
  return (
    <mesh position={[-1.2, 1.2, 0]} >
      <Html >
        <div className="loading">
          <img src={loading} style={{ width: 300, height: 300 }} />

          <h3> {progress} % loaded</h3>
        </div>
      </Html>
    </mesh>
  );
};

export default Loader;
